import * as React from 'react';
import { useState } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'
import ReactPaginate from 'react-paginate';
import { Button, CardLink, Col, Container, Fade, Row, Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faTimes, faEdit, faChevronDown, faChevronUp, faCopy, faFileExport} from '@fortawesome/free-solid-svg-icons';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ReadingPlansCopy from './readingPlanCopy';
import { LoadingSpinnerModal, ConfirmModal, DABTextBox } from '../../components/dab';
import { readingPlanAction } from '../../actions/readingPlanAction';
import { channelAction } from '../../actions/channelAction';
import { showAlert } from "../common/functions";
import moment from 'moment';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

interface IReadingPlanProps {
	dispatch: Dispatch<any>;
	readingPlanData: any;
	channelData: any;
	channelId: any;
}

const ReadingPlanList: React.SFC<IReadingPlanProps> = ({
	dispatch, readingPlanData, channelData, channelId }) => {

	const history = useHistory();

	const initialValue = [{ text: "", value: 0, checked: false, selected : false }];
	const initialInputValue = {
		channelId: -1,
		year: -1,
		pageNumber: 1,
		pageSize: 25,
		sortColumn: "YEAR",
		sortDirection: "desc"
	};

	const [isChannelLoaded, setIsChannelLoaded] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [selectedId, setSelectedId] = useState(0);
	const [currentPageNo, setCurrentPageNo] = useState(0);
	const [localFilter, setLocalFilter] = useState(initialInputValue);
	const [pageList, setPageList] = useState([1]);
	const [channelList, setChannelList] = useState(initialValue);
	const [yearList, setYearList] = useState(initialValue);
	const [filterYear, setFilterYear] = useState(initialValue);
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [showModal, setShowModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [isFormSubmitted, setIsFormSubmitted] = useState(false);
	const [showReadingPlanCopyModal, setShowReadingPlanCopyModal] = useState(false);
	const [selectedYear, setSelectedYear] = useState(0);
	const [selectedChannelTitle, setSelectedChannelTitle] = useState("");
	const [isMessageErr, setIsMessageErr] = useState(false);
	const [inputMessage, setInputMessage] = useState("");
	const [selChannelId, setSelChannelId] = useState(channelId);
	const [copyChannelId, setCopyChannelId] = useState(-1);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleCloseFilter = () => {
		handleToggle();
	}

	const handleClearFilter = () => {
		setFadeIn(false);
		readingPlanData.isFilterAndTotalCountDataLoaded = false;
		setCurrentPageNo(0);
		setFilterInput(initialInputValue);
		setLocalFilter(initialInputValue);
		sessionStorage.removeItem("Filter")
		setShowClearFilter(false);
		dispatch(readingPlanAction.readingPlanGetByFilter(filterInput));
		localStorage.removeItem("channelId");
		setSelChannelId(-1);
	}

	const handleToggle = () => setFadeIn(!fadeIn);

	const handleFilter = () => {
		setSelChannelId(localFilter.channelId);
		setFilterInput({
			...filterInput,
			channelId: localFilter.channelId,
			year: localFilter.year,
			pageNumber: 1
		});
		setCurrentPageNo(0);
		readingPlanData.isFilterAndTotalCountDataLoaded = false;
		if (localFilter.channelId == -1 && localFilter.year == -1) {
			setShowClearFilter(false);
		}
		else {
			setShowClearFilter(true);
		}
		handleToggle();
		localStorage.removeItem("channelId");
	};

	const handleSort = (sortColumn) => {
		var input = filterInput;
		var sDir = "asc"
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				sDir = "asc";
			}
			else {
				sDir = "desc";
			}
		}
		setFilterInput({
			...filterInput,
			sortColumn: sortColumn,
			sortDirection: sDir
		})
	};

	const handleSetPageNumber = (pageNo) => {
		setFilterInput({
			...filterInput,
			pageNumber: pageNo,
		});
	};

	const handleSortIcon = (sortColumn) => {
		var input = filterInput;
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronUp} />
			}
			else {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronDown} />
			}
		}
	}

	const handleCloseClick = () => {
		setIsMessageErr(false);
		setSelectedYear(0);
		setSelectedChannelTitle("");
		setInputMessage("");
		setShowDeleteModal(false);
	}

	const handleLoadDeleteModal = () => {
		if (inputMessage.toLowerCase() == "yes") {
			setIsMessageErr(false);
			dispatch(readingPlanAction.readingPlanDelete(selectedId));
			setShowModal(true);
			setShowDeleteModal(false);
		}
		else
		{
			setIsMessageErr(true);
		};
	};

	const handleInputMessageChange = (event) => {
		let value = event.target.value;
		setIsMessageErr(false);
		setInputMessage(value);
	};

	const selectForDelete = (id: number, title: string, year: number) => {
		setSelectedId(id);
		setSelectedChannelTitle(title);
		setSelectedYear(year);
		setInputMessage("");
		setShowDeleteModal(true);
	};

	const handleGetSortColumn = (display, value) => {
		return <div className='column-div' onClick={(e) => { handleSort(value); }}>
			{display}
			{value === filterInput.sortColumn && (handleSortIcon(value))}
		</div>
	};

	const handlePageClick = (data) => {
		handleSetPageNumber(data.selected + 1);
		setCurrentPageNo(data.selected);
	};

	React.useEffect(() => {
		if (!isChannelLoaded) {
			dispatch(channelAction.channelGetByfilter());
		}
		if (selChannelId > -1 && selectedYear > -1) {
			setFilterInput({ ...filterInput, channelId: selChannelId, year : selectedYear })
			setShowClearFilter(true)
		}
	}, []);

	React.useEffect(() => {
		var fromPage = sessionStorage.getItem("fromPage");

		if (fromPage && fromPage.trim().toLowerCase() === 'readingplan') {
			handleFilterRestore();
		}

		if (initialInputValue != filterInput) {
			sessionStorage.setItem("Filter", JSON.stringify(filterInput));
		} else {
			sessionStorage.removeItem("Filter");
		}

		dispatch(readingPlanAction.readingPlanGetByFilter(filterInput));
		setShowModal(true);
	}, [filterInput]);

	const handleFilterRestore = () => {
		var filter = sessionStorage.getItem("Filter");
		if (filter != null && filter.trim() != "") {
			var filterObj = JSON.parse(filter.toString());
			if (filterObj != null) {
				setShowClearFilter(true);
				setFilterInput(filterObj);
				setLocalFilter(filterObj);
				setCurrentPageNo(filterObj.pageNumber - 1)
				sessionStorage.removeItem("fromPage");
			}
		}
	}

	if (readingPlanData && readingPlanData.isListSuccess) {
		var list: any[] = [];
		list.push({ text: "All", value: -1 }) 
		if (readingPlanData.items.length > 0)
		{
			readingPlanData.items.forEach((data) =>
			{
				if (list.filter(obj => { return obj.value == data.year}).length == 0)
				{
					var item1 = { text: data.year, value: data.year };
					list.push(item1);
				}
			})
		}
		setFilterYear(list)
	}

	if (showModal && !readingPlanData.isLoading) {
		if (readingPlanData.isListSuccess) {
			readingPlanData.isListSuccess = false;
			readingPlanData.isSuccess = false;
			setShowModal(false);
			var total: number = readingPlanData.totalCount;
			var pList: number[] = [];
			if (total > initialInputValue.pageSize) {
				for (var i = 1; i <= (total / initialInputValue.pageSize); i++) {
					pList.push(i);
				}
				if ((total % initialInputValue.pageSize) > 0) {
					pList.push((parseInt((total / initialInputValue.pageSize).toString()) + 1));
				}
			}
			else {
				pList.push(1);
			}
			setPageList(pList);
		}
	}

	if (!isChannelLoaded && !channelData.isLoading) {
		if (channelData.isListSuccess) {
			channelData.isListSuccess = false;
			setIsChannelLoaded(true);
			var list: any[] = [];
			var checkedValue = false;

			list.push({ text: "All", value: -1, checked: true });
			if (channelList && channelList.length <= 1) {
				channelData.items.map((data) =>
				{
					if (data.channelId == filterInput.channelId) {
						checkedValue = true;
					}
					else
					{
						checkedValue = false;
					}
					var item1 = { text: data.title, value: data.channelId, checked: checkedValue };
					list.push(item1);
				});
				setChannelList(list);
			}

			if (yearList && yearList.length <= 1) {
				var list1: any[] = [];
				var year = new Date().getFullYear();
				checkedValue = false;
				list1.push({ text: "", value: -1, checked: true });
				for (var i1 = 0; i1 < 2; i1++) {
					var data = year + i1;
					if (filterInput.year == data) {
						checkedValue = true;
					}
					else {
						checkedValue = false;
					}
					var item2 = { text: data, value: data, checked: checkedValue };
					list1.push(item2);
				}
				setYearList(list1);
			}
		}
	}

	if (selectedId >= -1 && readingPlanData.isSuccess && readingPlanData.isDeleteCompleted && !readingPlanData.isError) {
		showAlert(readingPlanData.status, false);
		readingPlanData.isSuccess = false;
		readingPlanData.isDeleteCompleted = false;
		dispatch(readingPlanAction.readingPlanGetByFilter(filterInput));
		setSelectedId(-1);
	}

	if (selectedId >= 0 && !readingPlanData.isSuccess && readingPlanData.isDeleteCompleted && readingPlanData.isError) {
		readingPlanData.isError = false;
		readingPlanData.isDeleteCompleted = false;
		if (readingPlanData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(readingPlanData.status, true);
		}
		setSelectedId(-1);
		if (showModal) {
			setShowModal(false);
		}
	}

	if (isFormSubmitted && readingPlanData.isSuccess && !readingPlanData.isError) {
		readingPlanData.isSuccess = false;
		showAlert(readingPlanData.status, false);
		dispatch(readingPlanAction.readingPlanGetByFilter(filterInput));
		setSelectedId(-1);
		setIsFormSubmitted(false);
	}

	if (!readingPlanData.isSuccess && readingPlanData.isError) {
		readingPlanData.isError = false;
		if (readingPlanData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(readingPlanData.status, true);
		}
		setIsFormSubmitted(false);
		if (showModal) {
			setShowModal(false);
		}
	}
	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;
		setLocalFilter({
			...localFilter,
			[name]: (value && value !== null && value !== "") ? parseInt(value) : -1
		});
	};

	const handleSelectForReadingsPlanCopy = (data) => {
		setSelectedId(data.readingPlanId);
		setCopyChannelId(data.channelId);
		setShowReadingPlanCopyModal(true);
	}

	const handleToggleCopyModal = () => {
		setShowReadingPlanCopyModal(false);
	}

	const handleSubmit = (data) => {
		setShowReadingPlanCopyModal(false);
		if (data.channelId > 0 && data.year > 0) {
			setShowModal(true);
			setIsFormSubmitted(true);
			dispatch(readingPlanAction.readingPlanCopy({ readingPlanCopy: data }));
		}
	}

	const handleCalculatePercentage = (data) => {
		var year;
		if (data.year % 400 === 0 || (data.year % 100 !== 0 && data.year % 4 === 0)) {
			year = 366
		} else {
			year=365
		}
		return (data.readingPlanDayCount / year * 100).toFixed(2)
	}

	const handleExportReadingPlan = (val) => {
		dispatch(readingPlanAction.readingPlanGetDetail({
			readingPlanId: val.readingPlanId,
			pageNumber: 1,
			pageSize: 10,
			sortColumn: "",
			sortDirection: "desc"
		}));
		setShowModal(true);
	}

	const exportToCSV = (csvData: Object[], fileName: string) => {
		const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
		const fileExtension = ".xlsx";
		var wscols = [{ wpx: 100 }, { wpx: 150 }, { wpx: 100 }, { wpx: 250 }];
		var wsMerge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 3 } }]

		const ws = XLSX.utils.json_to_sheet([{}], { header: [fileName] });

		ws["!cols"] = wscols;
		ws['!merges'] = wsMerge;
		XLSX.utils.sheet_add_json(ws, csvData, { origin: 1 });
		
		const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
		const data = new Blob([excelBuffer], { type: fileType });

		FileSaver.saveAs(data, fileName + fileExtension);
	};

	if (readingPlanData) {
		if (readingPlanData.isDetailSuccess && readingPlanData.readingPlans && readingPlanData.readingPlans.readingPlanDays.length > 0) {
			readingPlanData.isDetailSuccess = false;
			var readingPlan: any[] = [];
			readingPlanData.detailItems.forEach((data) => {
				if (data.readingId > 0) {
					var date = moment(data.month + "-" + data.day + "-" + readingPlanData.readingPlans.year).format('LL')
					var reading = { Date: date, Bible: data.bibleTitle, Reading: data.readingTitle, "View Reading": window.location.origin+ "/reading?id=" + data.readingId }
					readingPlan.push(reading)
				}
			});

			exportToCSV(readingPlan,"Reading Plan "+ readingPlanData.readingPlans.year)
		}
	}

	const handleDetailNavigation = (data) => {
		sessionStorage.setItem("fromPage", "readingPlan");
		window.location.href = "/readingplan?id=" + data.readingPlanId
	}

	return (
		<div>
			<div className="reading-plan-list">
				<div className='card-box'>
					<Row className='filter-link-container'>
						<Col lg="8" className='column'>
							<CardLink onClick={handleToggle} className='card-box-link'>Filter List</CardLink>
							{showClearFilter ?
								<CardLink onClick={handleClearFilter} className='card-box-link-filter'>Clear Filter</CardLink>
								: <CardLink className='card-box-link-filter-disabled'>Clear Filter</CardLink>}
						</Col>
						<Button id="submit" className="btn-submit-frm" onClick={() => { window.location.href = '/readingplan?page=add' }} data-testid="createNewReadingPlan">Create New</Button>
					</Row>
					{fadeIn && (
						<Fade in={fadeIn} tag="div" className='card-fade'>
							<Container className='filter-container'>
								<div className='box-container'>
									<div>
										<Row >
											<Col lg="5">
												<label>Channel</label>
												<div data-testid="channelContainer">
													<Input type="select" className="form-select" id="channelId" required name="channelId" value={localFilter.channelId} onChange={(event) => { handleInputChange(event) }}>
														{
															channelList && channelList.map((data: any) =>
																<option key={data.value + "key"} value={data.value} selected={data.checked}>{data.text}</option>
														)}
													</Input>
												</div>
											</Col>
											<Col lg="4">
												<label>Year</label>
												<div data-testid="yearContainer">
													<Input type="select" className="form-select" id="year" required name="year" value={localFilter.year} onChange={(event) => { handleInputChange(event) }}>
														{filterYear && filterYear.map((data: any) =>
															<option key={data.value + "key"} value={data.value} selected={ data.checked}>{data.text}</option>)}
													</Input>
												</div>
											</Col>
											<Col lg="3">
												<div className='close-div'>
													<FontAwesomeIcon cursor='pointer' size='3x' data-bs-toggle="tooltip"
														data-bs-placement="bottom" title="Close" icon={faTimes}
														onClick={handleCloseFilter} />
												</div>
											</Col>
										</Row>
										<Row>
											<Col lg="11">

											</Col>
											<Col lg="1">
												<Button id="submit" className="inner-filter-link" onClick={() => { handleFilter(); }}>Filter</Button>
											</Col>
										</Row>
									</div>
								</div>
							</Container>
						</Fade>)}
				</div>
				<div className="reading-plan-table">
					<table className="table table-hover text-center" data-testid="readingPlanTable">
						<thead data-testid="RPHeader">
							<tr>
								<th scope="col" data-testid="RPDetailsColumn">Details</th>
								<th scope="col" data-testid="RPYearColumn">{handleGetSortColumn("Year", "YEAR")}</th>
								<th scope="col" data-testid="RPChannelColumn">{handleGetSortColumn("Channel", "CHANNEL")}</th>
								<th scope="col" data-testid="RPCompleteColumn">{handleGetSortColumn("% Complete", "Complete")}</th>
								<th scope="col" data-testid="RPCopyColumn">Copy</th>
								<th scope="col" data-testid="RPExportColumn">Export</th>
								<th scope="col"data-testid="RPDeleteColumn">Delete</th>
							</tr>
						</thead>
						<tbody data-testid="readingPlanTableBody">
							{
								readingPlanData && readingPlanData.items.map((data: any) =>
									<tr key={data.readingPlanId} >
										<th scope="row" data-testid="detailReadingButton">
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faEdit} title="Details"
												onClick={() => { handleDetailNavigation(data) }} />
										</th>
										<td data-testid="readingPlanYear">{data.year}</td>
										<td data-testid="readingPlanChannelTitle">{data.channelTitle}</td>
										<td data-testid="readingPlanDayCompleted">{handleCalculatePercentage(data)}% </td>
										<td data-testid="copyReadingPlanButton">
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faCopy}
												data-bs-toggle="tooltip" data-bs-placement="bottom" title="Copy" onClick={() => { handleSelectForReadingsPlanCopy(data); }} />
										</td>
										<td data-testid="exportReadingPlanButton">
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faFileExport}
												data-bs-toggle="tooltip" data-bs-placement="bottom" title="Export reading plan" onClick={() => { handleExportReadingPlan(data); }} />
										</td>
										<td data-testid="deleteReadingPlanButton">
											<FontAwesomeIcon cursor='pointer' size='2x' icon={faTrashAlt} data-bs-toggle="tooltip"
												data-bs-placement="bottom" title="Delete" onClick={() => { selectForDelete(data.readingPlanId, data.channelTitle, data.year); }} />
										</td>
									</tr>
								)}
							{readingPlanData && readingPlanData.items.length <= 0 &&
								<tr className="no-data">
									<th scope="row" colSpan={7}>
										<h4> No data found </h4>
									</th>
								</tr>}
						</tbody>
					</table>
				</div>
				<div className="pagination">
					<ReactPaginate
						previousLabel={'<<'}
						nextLabel={'>>'}
						breakLabel={'...'}
						pageCount={pageList.length}
						marginPagesDisplayed={2}
						pageRangeDisplayed={10}
						onPageChange={handlePageClick}
						forcePage={currentPageNo}
						containerClassName={'pagination'}
						pageClassName={"page-item"}
						previousClassName={"page-item"}
						breakClassName={"page-item"}
						breakLinkClassName={"page-link"}
						nextClassName={"page-item"}
						pageLinkClassName={"page-link"}
						previousLinkClassName={"page-link"}
						nextLinkClassName={"page-link"}
						activeClassName={'active'}
					/>
				</div>
				<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
				<ReadingPlansCopy isShowModal={showReadingPlanCopyModal} channelList={channelList} onSubmit={handleSubmit} yearList={yearList} handleToggle={handleToggleCopyModal} readingPlanId={selectedId} defaultChannelId={copyChannelId} />
				<Modal isOpen={showDeleteModal} backdrop="static" centered data-testid="deleteModal">
					<ModalHeader className="modal-header" >
						Delete Reading Plan</ModalHeader>
					<ModalBody className="modal-body">
						<div className={["col-form-label"].join(" ")} data-testid="ReadingPlanDeleteMessage">
							Are you sure you want to delete the {selectedYear} reading plan for {selectedChannelTitle}? 
							This action will remove all days from the plan and you won't be able to 
							generate a new episode automatically from this plan. 
							Please type the word YES to delete this reading plan.
						</div>
						<form name="deleteReadingPlanForm">
							<div className={["row mb-3"].join(" ")}>
								<div className={["col-sm-6"].join(" ")} data-testid="messageContainer">
									<DABTextBox data-testid="readingPlanMessage" className={["form-control"].join(" ")} id="Message" value={inputMessage} isRequired={true}
										onChange={(event) => { handleInputMessageChange(event) }} isHover={false} />
									<div style={{ display: `${isMessageErr ? '' : 'none'}` }}>
										<label data-testid="messageErr" className="text-danger">Cannot proceed to delete since the required message is not typed.</label>
									</div>
								</div>
							</div>
						</form>
					</ModalBody>
					<ModalFooter>
						<Button type="button" color="secondary" data-bs-dismiss="modal" onClick={handleCloseClick} data-testid="cancelDeleteButton">Cancel</Button>
						<Button type="button" color="primary" onClick={handleLoadDeleteModal} data-testid="confirmDeleteButton">Confirm Delete</Button>
					</ModalFooter>
				</Modal>
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { readingPlanData, channelData } = state;
	return {
		readingPlanData, channelData
	};
};

export default connect(mapStateToProps)(ReadingPlanList);
